import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FormGroup, Row, Col, Label, Input } from "reactstrap";

import jsonData from "../../components/json/accountsType.json";
import countriesData from "../../components/json/countriesStates.json";
import { toast } from "react-toastify";
import { clientService, activitiesServices } from "../../services";
import countries from "../../components/json/resitrictedCountries.json";
import TokenService from "../../services/token.service";
import {
  formatAccountTypeSelectLabel,
  sortAccountTypesForSelect,
} from "../../utils/accountTypeSelectLabel";
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
// import { PiExclamationMarkDuotone } from "react-icons/pi";
import { useTranslation } from "react-i18next";
import Select from "react-select";

import { Button, CustomForm } from "../Form/style";

import uploadIcon from "../../assets/images/uploadIcon.svg";
import toolTipIcon from "../../assets/images/toopTip.jpg";

import "../Form/style.css";
import "../../index.css";

const CREDIT_ACCOUNT_IDS = [63, 64, 65];

/** Pure filter so URL sync can use ptr/rm from the query string before React state updates. */
function computeFilteredAccountTypes({
  platform,
  country,
  ptrValue,
  refValue,
  morocco,
  referrar,
  isCreditCampaign,
}) {
  let result;

  if (country === "EGYPT" || country === "TURKEY") {
    result = jsonData.filter((item) =>
      platform === "MT5"
        ? item["TP platform"] === platform && item["Server Number"] === 6
        : item["TP platform"] === platform && item["Server Number"] === 1
    );
  } else if (ptrValue && refValue !== "38" && !morocco) {
    result = jsonData.filter(
      (item) =>
        item["TP platform"] === platform && Number(item["ib"]) === 1
    );
  } else if (ptrValue && refValue !== "38" && morocco) {
    result = jsonData.filter(
      (item) =>
        item["TP platform"] === platform && Number(item["ib"]) === 3
    );
  } else if (refValue === "38") {
    result = jsonData.filter(
      (item) =>
        item["TP platform"] === platform && item["Server Number"] === 2
    );
  } else if (morocco) {
    result = jsonData.filter(
      (item) =>
        item["TP platform"] === platform && item["Server Number"] === 3
    );
  } else if (referrar === "98724816") {
    result = jsonData.filter(
      (item) =>
        item["TP platform"] === platform && item["Server Number"] === 1
    );
  } else {
    result = jsonData.filter(
      (item) =>
        item["TP platform"] === platform && item["Server Number"] === 1
    );
  }

  if (!isCreditCampaign) {
    result = result.filter((item) => !CREDIT_ACCOUNT_IDS.includes(item.Id));
  }

  return result;
}

export const MoroccoForm = ({ setLoading, loading, setSubmittedData }) => {
  const [refValue, setRefValue] = useState("");
  const [ptrValue, setPtrValue] = useState("");
  const [referrar, setReferrar] = useState("");
  const [agreementId, setAgreementId] = useState("");
  const [filteredAccountTypes, setFilteredAccountTypes] = useState([]);
  const [emailError, setEmailError] = useState(0);
  const [imageList, setImageList] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [countryList, setCountriesList] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [entityValue, setEntityValue] = useState(false);
  const [utmMediumValue, setUtmMediumValue] = useState("");
  const [morocco, setMorocco] = useState(false);
  const [ipInfo, setIpInfo] = useState(null);
  const [email, setEmail] = useState({ type: "", value: "" });
  const [phoneError, setPhoneError] = useState(false);
  const [debouncedEmail, setDebouncedEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const [utmArray, setUtmArray] = useState({});
  const [couponCode, setCopponCode] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const initialLoad = useRef(true);
  const ibCreditRequestSeqRef = useRef(0);

  // This initialization intentionally reacts only to location/environment inputs.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    console.log("[MoroccoForm] mount", {
      search: typeof window !== "undefined" ? window.location.search : "",
      apiBase: process.env.REACT_APP_API_URL || "(missing REACT_APP_API_URL)",
    });
  }, []);

  const [isCreditCampaign, setIsCreditCampaign] = useState(false);
  const [isCreditCampaignLoading, setIsCreditCampaignLoading] = useState(false);

  const [acceptedCreditTerms, setAcceptedCreditTerms] = useState(false);

  const { t, i18n } = useTranslation();


  useEffect(() => {
    const fetchIPInfo = async () => {
      try {
        const response = await fetch(
          "https://ipinfo.io/json?token=52a7645817b83a"
        );
        const data = await response.json();
        setIpInfo(data);
      } catch (error) {
        console.error("Error fetching IP information:", error);
      }
    };

    fetchIPInfo();
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const refParam = searchParams.get("rm");
    const ptrParam = searchParams.get("ptr");
    let ibUrl = window.location.origin + `/?ptr=${ptrParam}&rm=${refParam}`;

    if (ibUrl === `${window.location.origin}/?ptr=2000095497&rm=69`) {
      window.location.href = `https://signup-ma.godocm.com/?rm=101&utm_medium=godoweb_ma`;
    }
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const refParam = searchParams.get("rm");
    const ptrParam = searchParams.get("ptr");
    const refAddParam = searchParams.get("ref");
    const agreementParam = searchParams.get("agr");
    const entityParam = searchParams.get("entity");
    const platform = searchParams.get("platform");
    const partner = searchParams.get("partner");
    const nationality = searchParams.get("nationality");
    const utmSource = searchParams.get("utm_source");
    const utmCategory = searchParams.get("utm_category");
    const utm = searchParams.get("utm_medium");
    const utmCampaign = searchParams.get("utm_campaign");

    const effectivePtr =
      partner === "traderscaptain"
        ? "2000111910"
        : ptrParam || ptrValue;
    const effectiveRef =
      partner === "traderscaptain" ? "95" : refParam || refValue;
    const effectiveReferrar = refAddParam || referrar;

    const listAccountTypes = (pf, moroccoFlag = morocco) =>
      computeFilteredAccountTypes({
        platform: pf,
        country: formData.step1.country,
        ptrValue: effectivePtr,
        refValue: effectiveRef,
        morocco: moroccoFlag,
        referrar: effectiveReferrar,
        isCreditCampaign,
      });

    setUtmArray({
      utmCampaign: utmCampaign || "",
      utmCategory: utmCategory || "",
      utmSource: utmSource || "",
      utmMedium: utmMediumValue || utm || "",
    });

    if (entityParam === "FSC") {
      const removeCountry = [
        "AFGHANISTAN",
        "CUBA",
        "GHANA",
        "IRAN",
        "LIBYA",
        "MYANMAR",
        "PANAMA",
        "SOUNTH SUDAN",
        "SYRIA",
        "USA",
        "YEMEN",
      ];
      const filterCountry = countriesData.filter(
        (country) => !removeCountry.includes(country.name)
      );
      setCountriesList(filterCountry);
    } else if (entityParam === "SCA") {
      const filterCountry = countriesData.filter(
        (country) => country.name === "UNITED ARAB EMIRATES"
      );
      setCountriesList(filterCountry);
    } else {
      setCountriesList(countriesData);
    }

    if (nationality === "IRAN") {
      formData.step1.nationality = "IRAN";
      formData.step1.nationalityCode = "IR";
      formValueChange("step2", "nationality", "IRAN");
      formValueChange("step2", "nationalityCode", "IR");
    }

    if (nationality) {
      const formattedCountry =
        nationality.charAt(0) + nationality.slice(1).toLowerCase();
      const country = countries.find(
        (country) => country.name === formattedCountry
      );
      if (country) {
        formData.step1.country = nationality;
        formData.step1.countryCode = country.iso2;
        formValueChange("step1", "country", nationality);
        formValueChange("step1", "countryCode", country.iso2);
      }
    }

    setFilteredAccountTypes(
      listAccountTypes(formData.step1.platform || "MT5")
    );
    // Parse the query parameters from the URL
    // Get the value of the 'ref' parameter
    if (partner === "traderscaptain") {
      setRefValue("95");
      setPtrValue("2000111910");
    }

    if (entityParam) {
      setEntityValue(entityParam);
    }

    // mobile app url
    if (
      platform === "MT5" &&
      utm === "godotrader_app" &&
      entityParam === "FSA" &&
      ipInfo !== null &&
      ipInfo.country === "MA"
    ) {
      window.location.href = `https://signup-ma.godocm.com/?entity=FSA_MA&utm_medium=godotrader_app&platform=MT5`;
    }

    if (
      platform === "MT5" &&
      utm === "godotrader_app" &&
      entityParam === "FSA_MA"
    ) {
      setUtmMediumValue(utm);
      setMorocco(true);
      formData.step1.platform = "MT5";
      formData.step1.utmMedium = utm;
      setFilteredAccountTypes(listAccountTypes("MT5", true));
      const filterCountry = countriesData.filter(
        (country) => country.name === "MOROCCO"
      );
      setCountriesList(filterCountry);
    }

    if (
      platform === "MT5" &&
      utm === "godotrader_app" &&
      entityParam === "FSA"
    ) {
      setUtmMediumValue(utm);
      formData.step1.platform = "MT5";
      formData.step1.utmMedium = utm;
      setFilteredAccountTypes(listAccountTypes("MT5"));
    }

    //desktop url
    if (utm === "godoweb_ma" && !platform) {
      setUtmMediumValue(utm);
      setMorocco(true);
      formData.step1.utmMedium = utm;
      const filterCountry = countriesData.filter(
        (country) => country.name === "MOROCCO"
      );
      setCountriesList(filterCountry);
    }

    if (
      platform === "MT5" &&
      utm === "godoweb_ma" &&
      entityParam === "FSA_MA"
    ) {
      setUtmMediumValue(utm);
      setMorocco(true);
      formData.step1.platform = "MT5";
      formData.step1.utmMedium = utm;
      setFilteredAccountTypes(listAccountTypes("MT5", true));
      const filterCountry = countriesData.filter(
        (country) => country.name === "MOROCCO"
      );
      setCountriesList(filterCountry);
    }

    // Set the value to the state
    if (refParam) {
      setRefValue(refParam);
    }

    if (refAddParam) {
      setReferrar(refAddParam);

      if (refAddParam === "98724816") {
        setFilteredAccountTypes(listAccountTypes("MT4"));
        formData.step1.platform = "MT4";
      }
    }
    if (agreementParam) {
      setAgreementId(agreementParam);
    }

    if (ptrParam) {
      setPtrValue(ptrParam);
    }

    // clientService.authorization().then((res) => {
    //     const token = res.token;
    //     const decryptToken = decryptData(token);
    //     TokenService.setUser(decryptToken);
    // }).catch((err) => {
    //     console.log('Error for auth is ', err);
    //     toast.error("Authorization error!");
    // });
    TokenService.setUser(process.env.REACT_APP_TOKEN);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- URL/query sync only; full deps would re-run on every formData change
  }, [morocco, utmMediumValue, ipInfo]);

  useEffect(() => {
    const seq = ++ibCreditRequestSeqRef.current;

    const params = new URLSearchParams(location.search);
    const ptrFromUrl = (params.get("ptr") || "").trim();
    const rmFromUrl = (params.get("rm") || "").trim();
    const agrFromUrl = (params.get("agr") || "").trim();
    const ptrNumeric = parseInt(ptrFromUrl, 10);
    const hasIbCreditLinkParams =
      Boolean(ptrFromUrl) &&
      Boolean(rmFromUrl) &&
      Boolean(agrFromUrl) &&
      Number.isFinite(ptrNumeric) &&
      ptrNumeric >= 1;

    const isStale = () => seq !== ibCreditRequestSeqRef.current;

    const fetchIbCreditStatus = async () => {
      if (!hasIbCreditLinkParams) {
        console.log("[MoroccoForm] IB credit: skip (need ptr, rm, agr)", {
          seq,
          ptr: ptrFromUrl || null,
          rm: rmFromUrl || null,
          agr: agrFromUrl || null,
        });
        if (!isStale()) {
          setIsCreditCampaign(false);
          setIsCreditCampaignLoading(false);
          setAcceptedCreditTerms(false);
        }
        return;
      }

      console.log("[MoroccoForm] IB credit: calling API", {
        seq,
        ptr: ptrFromUrl,
        ptrId: ptrNumeric,
        rm: rmFromUrl,
        agr: agrFromUrl,
        apiBase: process.env.REACT_APP_API_URL || "(missing REACT_APP_API_URL)",
      });

      if (!isStale()) {
        setIsCreditCampaignLoading(true);
      }

      try {
        const response = await clientService.getIbCreditStatus(ptrFromUrl, {
          rm: rmFromUrl,
        });
        const raw =
          response?.isIbCredit ?? response?.creditisib;
        const creditEnabled =
          raw === true ||
          raw === 1 ||
          raw === "1" ||
          Number(raw) === 1;

        console.log("[MoroccoForm] IB credit: API result", {
          seq,
          stale: isStale(),
          creditEnabled,
          creditisib: creditEnabled ? 1 : 0,
          isIbCredit: response?.isIbCredit,
          agentMatch: response?.agentMatch,
          ptr: ptrFromUrl,
          rm: rmFromUrl,
          rawPayload: response,
        });

        if (isStale()) {
          return;
        }

        setIsCreditCampaign(creditEnabled);

        setFormData((prevFormData) => {
          const isCreditAccountType =
            prevFormData.step1.accountType === "63" ||
            prevFormData.step1.accountType === "64";

          if (creditEnabled) {
            return {
              ...prevFormData,
              step1: {
                ...prevFormData.step1,
                accountType: isCreditAccountType
                  ? prevFormData.step1.accountType
                  : "",
                accountTypeCurrency: isCreditAccountType
                  ? prevFormData.step1.accountTypeCurrency
                  : "",
              },
            };
          }

          return {
            ...prevFormData,
            step1: {
              ...prevFormData.step1,
              accountType: isCreditAccountType
                ? ""
                : prevFormData.step1.accountType,
              accountTypeCurrency: isCreditAccountType
                ? ""
                : prevFormData.step1.accountTypeCurrency,
            },
          };
        });

        if (!creditEnabled) {
          setAcceptedCreditTerms(false);
        }
      } catch (error) {
        if (isStale()) {
          return;
        }

        console.error("[MoroccoForm] IB credit API error:", {
          seq,
          message: error?.message,
          status: error?.response?.status,
          data: error?.response?.data,
          ptr: ptrFromUrl,
        });
        setIsCreditCampaign(false);
        setAcceptedCreditTerms(false);
      } finally {
        if (!isStale()) {
          setIsCreditCampaignLoading(false);
        }
      }
    };

    fetchIbCreditStatus();
  }, [location.search]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedEmail(email); // Set the debounced email after delay
    }, 500);

    return () => {
      clearTimeout(handler); // Clear the timeout if the user keeps typing
    };
  }, [email]);

  // Call the API when the debounced email changes (after typing stops)
  useEffect(() => {
    const checkEmailExistence = async () => {
      if (debouncedEmail) {
        try {
          const res = await clientService.emailExist(debouncedEmail);
          if (res.agentId) {
            email.type === "email"
              ? setErrorMessage(true)
              : setPhoneError(true);
          } else {
            email.type === "email"
              ? setErrorMessage(false)
              : setPhoneError(false);
          }
        } catch (error) {
          console.error("Error checking email:", error);
        }
      }
    };

    checkEmailExistence();
  }, [debouncedEmail, email.type]);

  useEffect(() => {
    // Ensure 'ptr' is present on initial load
    if (initialLoad.current) {
      initialLoad.current = false;
      const searchParams = new URLSearchParams(location.search);

      // Check for required search parameters
      if (
        !searchParams.has("ptr") ||
        !searchParams.has("rm") ||
        !searchParams.has("nationality")
      ) {
        const newUrl = `${location.pathname}?${searchParams.toString()}`;
        navigate(newUrl, { replace: true });
      } else if (
        searchParams.has("nationality") &&
        searchParams.get("nationality") === "MOROCCO"
      ) {
        // Redirect directly to the Moroccan URL without localhost prefix
        const newUrl = `https://signup-ma.godocm.com/?${searchParams.toString()}`;
        window.location.href = newUrl;
      }
    }
  }, [location, navigate]);

  const reloadHandler = (country) => {
    // Get current search params
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("nationality", country);

    // Construct the new URL
    let newUrl;
    if (country === "MOROCCO") {
      newUrl = `https://signup-ma.godocm.com/?${searchParams.toString()}`;
      window.location.href = newUrl;
    } else {
      newUrl = `${location.pathname}?${searchParams.toString()}`;
      // Push the new URL to the history
      navigate(newUrl);
    }
  };

  const [formData, setFormData] = useState({
    step1: {
      agentId: refValue,
      parentId: ptrValue,
      entity: entityValue ? entityValue : "FSC",
      callStatus: "New Lead",
      firstName: "",
      email: "",
      phone: "",
      accountType: "",
      accountTypeCurrency: "",
      password: "",
      confirmPassword: "",
      country: "",
      countryCode: "",
      platform: "",
      utmMedium: "",
      couponeCode: ""
    },
    step2: {
      nationality: "",
      nationalityCode: "",
      state: "",
      address: "",
      proofOfAddress: "",
      emiratesId: "",
      idType: "",
      idTypeCode: "",
      passportIdNo: "",
      year: "",
      month: "",
      day: "",
      proofOfIdentity: "",
      proofOfIdentityBack: "",
      residency: "",
      residencyCode: "",
      resProofOfAddress: "",
      annualIncome: "",
      netWorth: "",
      modeOfPayment: "",
      modeOfPaymentCode: "",
      sourceOfFunds: "",
      sourceOfFundsCode: "",
      sourceOfIncome: "",
      taxResidency: "",
      taxIdentificationNumber: "",
      additional: "",
    },
    step3: {
      experiencedTrading: false,
      sharesFrequency: "",
      cfdFrequency: "",
      powerOfAttorney: "",
      learn: true,
      accountTradedByOthers: false,
      acceptTradingTerms: false,
    },
    step4: {
      usCitizen: false,
      acknowledge: false,
      politicallyExposed: false,
      beneficialOwnerCode: "",
      declaration: false,
    },
    // Add more steps as needed
  });

  const data = {
    agentId: refValue || "33",
    parentId: ptrValue || formData.step1.parentId,
    entity: entityValue ? entityValue : "FSC",
    firstName: formData.step1.firstName,
    email: formData.step1.email,
    platform: formData.step1.platform,
    accountType: formData.step1.accountType,
    accountTypeCurrency: formData.step1.accountTypeCurrency,
    country: formData.step1.country,
    countryCode: formData.step1.countryCode,
    phone: formData.step1.phone,
    ...utmArray,
    agreementId: agreementId,
    couponeCode: formData.step1.couponeCode,

    proofOfIdentity: formData.step2.proofOfIdentity,
    proofOfIdentityBack: formData.step2.proofOfIdentityBack,
    residency: formData.step2.residency,
    residencyCode: formData.step2.residencyCode,
    resProofOfAddress: formData.step2.resProofOfAddress,
    sourceOfFunds: formData.step2.sourceOfFunds,
    sourceOfFundsCode: formData.step2.sourceOfFundsCode,
    taxIdentificationNumber: formData.step2.taxIdentificationNumber,
    accountTradedByOthers: formData.step3.accountTradedByOthers,
    acceptTradingTerms: formData.step3.acceptTradingTerms,
    usCitizen: formData.step4.usCitizen,
    declaration: formData.step4.declaration,

    accountStatus: "New",
    isLead: true,
    isClient: false,
  };

  const isCreditAccountSelected = formData.step1.accountType === "63" || formData.step1.accountType === "64";
  if (isCreditCampaign && isCreditAccountSelected) {
    data.acceptedCreditTerms = acceptedCreditTerms;
  }

  const [validationErrors, setValidationErrors] = useState({
    step1: {
      firstName: false,
      phone: false,
      accountType: false,
      otpValue: false,
      country: false,
      countryCode: false,
      password: false,
      confirmPassword: false,
      platform: false,
    },
    step2: {
      nationality: false,
      nationalityCode: false,
      address: false,
      proofOfAddress: false,
      emiratesId: false,
      idType: false,
      idTypeCode: false,
      passportIdNo: false,
      dob: false,
      day: false,
      month: false,
      year: false,
      proofOfIdentity: false,
      proofOfIdentityBack: false,
      residency: false,
      residencyCode: false,
      resProofOfAddress: false,
      annualIncome: false,
      netWorth: false,
      modeOfPayment: false,
      modeOfPaymentCode: false,
      sourceOfFunds: false,
      sourceOfFundsCode: false,
      source_Of_Income: false,
      taxResidency: false,
      taxIdentificationNumber: false,
      additional: false,
    },
    step3: {
      experiencedTrading: false,
      sharesFrequency: false,
      cfdFrequency: false,
      learn: false,
      accountTradedByOthers: false,
      powerOfAttorney: false,
      acceptTradingTerms: false,
    },
    step4: {
      usCitizen: false,
      acknowledge: false,
      politicallyExposed: true,
      beneficialOwnerCode: false,
      declaration: false,
    },
    // other steps...
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const partnerParam = params.get("partner");
    const effectivePtr =
      partnerParam === "traderscaptain"
        ? "2000111910"
        : params.get("ptr") || ptrValue;
    const effectiveRef =
      partnerParam === "traderscaptain" ? "95" : params.get("rm") || refValue;
    const effectiveReferrar = params.get("ref") || referrar;
    const platform = formData.step1.platform || "MT5";
    let list = [
      ...computeFilteredAccountTypes({
        platform,
        country: formData.step1.country,
        ptrValue: effectivePtr,
        refValue: effectiveRef,
        morocco,
        referrar: effectiveReferrar,
        isCreditCampaign,
      }),
    ];
    const countryName = formData.step1.country;
    if (
      list.length === 0 &&
      countryName !== "EGYPT" &&
      countryName !== "TURKEY"
    ) {
      const pf = platform || "MT5";
      list = jsonData.filter(
        (item) =>
          item["TP platform"] === pf && item["Server Number"] === 1
      );
      if (!isCreditCampaign) {
        list = list.filter((item) => !CREDIT_ACCOUNT_IDS.includes(item.Id));
      }
      console.warn("[MoroccoForm] account types empty; using server-1 fallback", {
        platform: pf,
        count: list.length,
      });
    }

    if (
      isCreditCampaign &&
      platform === "MT5" &&
      Boolean(String(effectivePtr || "").trim()) &&
      effectiveRef !== "38"
    ) {
      const have = new Set(list.map((i) => i.Id));
      const extra = jsonData.filter(
        (row) =>
          CREDIT_ACCOUNT_IDS.includes(row.Id) &&
          row["TP platform"] === "MT5" &&
          !have.has(row.Id)
      );
      list = [...list, ...extra];
    }

    console.log("[MoroccoForm] accountType options", {
      platform,
      ptr: effectivePtr,
      rm: effectiveRef,
      refLink: effectiveReferrar,
      morocco,
      isCreditCampaign,
      isCreditCampaignLoading,
      count: list.length,
      labels: list.map((i) => i["Account type"]),
    });
    setFilteredAccountTypes(list);
  }, [
    isCreditCampaign,
    formData.step1.platform,
    formData.step1.country,
    ptrValue,
    refValue,
    morocco,
    referrar,
    location.search,
    isCreditCampaignLoading,
  ]);

  const formValueChange = (step, name, value) => {
    // Regular expression for English letters and basic punctuation
    const englishRegex = /^[a-zA-Z0-9\s.,'?!@#$%^&:*()_+=-]*$/;
    const uploadedFileNames = [
      "proofOfIdentity",
      "proofOfIdentityBack",
      "resProofOfAddress",
      "sourceOfIncome",
      "emiratesId",
    ];

    if (name === "email") {
      setEmail({ type: "email", value: value });
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(value)) {
        setEmailError(1); // Set email error state if the email is invalid
      } else {
        setEmailError(0); // Clear email error state if the email is valid
      }
    }

    if (name === "phone") {
      const phoneNumber = value.replace(/\s+/g, "");
      setEmail({ type: "phone", value: phoneNumber });
      setFormData((prevFormData) => ({
        ...prevFormData,
        [step]: {
          ...prevFormData[step],
          [name]: value.replace(/[^\d]/g, ""),
        },
      }));
    } else if (englishRegex.test(value)) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [step]: {
          ...prevFormData[step],
          [name]: value,
        },
      }));
    } else if (uploadedFileNames.includes(name)) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [step]: {
          ...prevFormData[step],
          [name]: value,
        },
      }));
    }
  };

  // const combineValidation = () => {
  //   const { firstName, email, phone, platform, accountType, country } =
  //     formData.step1;
  //   const {
  //     proofOfIdentity,
  //     proofOfIdentityBack,
  //     sourceOfFunds,
  //     resProofOfAddress,
  //     taxIdentificationNumber,
  //     emiratesId,
  //   } = formData.step2;
  //   const { acceptTradingTerms, accountTradedByOthers } = formData.step3;
  //   const { usCitizen, acknowledge } = formData.step4;

  //   // Check each field individually and set their validity
  //   const isfirstNameValid = firstName.trim() !== "";
  //   const isEmailValid = email.trim() !== "";
  //   const isPhoneValid = phone.trim() !== "";
  //   const isPlatform = platform !== "";
  //   const isAccountTypeValid = accountType !== "";
  //   const isCountryValid = country !== "";
  //   const isSourceOfFunds = sourceOfFunds;
  //   const isProofOfIdentity = proofOfIdentity !== "";
  //   const isAcceptTradingTerms = acceptTradingTerms !== false;
  //   const isAccountTradedByOthers = accountTradedByOthers !== false;
  //   const isTaxIdentificationNumber = taxIdentificationNumber !== "";
  //   const isAcknowledge = acknowledge !== false;
  //   const isEmiratesId = emiratesId !== "";

  //   const resitrictedCountriesCountried = ['TURKEY', 'EGYPT', 'IRAQ', 'JORDAN'];
  //   const isNotAllowed = resitrictedCountriesCountried.includes(formData?.step1?.country);

  //   let documentUpload = isNotAllowed ? false : true;
  //   const uploadedFiles = [
  //     proofOfIdentity,
  //     proofOfIdentityBack,
  //     resProofOfAddress,
  //     emiratesId,
  //   ];

  //   if (!isNotAllowed && proofOfIdentity === "" && resProofOfAddress === "") {
  //     toast.error(`Please Upload the requested files doc`);
  //   }

  //   if (selectedCountryCode === "ae" && !emiratesId) {
  //     toast.error(`Please Upload Emirated Id`);
  //   }

  //   if (proofOfIdentity !== "") {
  //     documentUpload = true;
  //     for (let i = 0; i < uploadedFiles.length; i++) {
  //       for (let j = i + 1; j < uploadedFiles.length; j++) {
  //         if (uploadedFiles[i] && uploadedFiles[i] === uploadedFiles[j]) {
  //           toast.error(`Uploaded files could not be the same`);
  //           return (documentUpload = false);
  //         }
  //       }
  //     }
  //   }

  //   // Set the validation errors dynamically for each field
  //   setValidationErrors((prevErrors) => ({
  //     ...prevErrors,
  //     step1: {
  //       ...prevErrors.step1,
  //       firstName: !isfirstNameValid,
  //       email: !isEmailValid,
  //       phone: !isPhoneValid,
  //       platform: !isPlatform,
  //       accountType: !isAccountTypeValid,
  //       country: !isCountryValid,
  //     },
  //     step2: {
  //       ...prevErrors.step2,
  //       sourceOfFunds: !isSourceOfFunds,
  //       proofOfIdentity: !isProofOfIdentity,
  //       resProofOfAddress: !resProofOfAddress,
  //       taxIdentificationNumber: usCitizen && !isTaxIdentificationNumber,
  //       emiratesId: selectedCountryCode === "ae" && !isEmiratesId,
  //     },
  //     step3: {
  //       ...prevErrors.step3,
  //       acceptTradingTerms: !isAcceptTradingTerms,
  //       accountTradedByOthers: !isAccountTradedByOthers,
  //     },
  //     step4: {
  //       ...prevErrors.step4,
  //       acknowledge: selectedCountryCode === "ae" && !isAcknowledge,
  //     },
  //   }));

  //   // Return true if all fields are valid, false otherwise
  //   const validTrue =
  //     isfirstNameValid &&
  //     isEmailValid &&
  //     isPhoneValid &&
  //     isAccountTypeValid &&
  //     isCountryValid &&
  //     documentUpload &&
  //     isSourceOfFunds &&
  //     isProofOfIdentity &&
  //     isAcceptTradingTerms &&
  //     isAccountTradedByOthers &&
  //     (usCitizen ? isTaxIdentificationNumber : !isTaxIdentificationNumber) &&
  //     (selectedCountryCode !== "ae" ? !isAcknowledge : isAcknowledge && isEmiratesId);

  //   if (!validTrue) {
  //     console.log(
  //       "validation: ",
  //       validTrue,
  //       selectedCountryCode !== "ae" ? !isAcknowledge : isAcknowledge
  //     );
  //     toast.error("Please fill all the fields!");
  //     return false;
  //   }
  //   return true;
  // };

  const combineValidation = () => {
    const validationMessages = [];
    const { step1, step2, step3, step4 } = formData;
    const {
      firstName = "",
      email = "",
      phone = "",
      platform = "",
      accountType = "",
      country = "",
    } = step1;

    const {
      proofOfIdentity = "",
      sourceOfFunds = "",
      resProofOfAddress = "",
      taxIdentificationNumber = "",
      emiratesId = "",
    } = step2;

    const { acceptTradingTerms = false, accountTradedByOthers = false } = step3;
    const { usCitizen = false, acknowledge = false } = step4;

    const restrictedCountries = ["TURKEY", "EGYPT", "IRAQ", "JORDAN"];
    const isRestricted = restrictedCountries.includes(country);
    const isUAE = selectedCountryCode === "ae";

    // Base validations
    const validations = {
      firstName: firstName.trim() !== "",
      email: email.trim() !== "",
      phone: phone.trim() !== "",
      platform: platform.trim() !== "",
      accountType: accountType.trim() !== "",
      country: country.trim() !== "",
      sourceOfFunds: !!sourceOfFunds,
      proofOfIdentity: !isRestricted ? !!proofOfIdentity : true,
      // resProofOfAddress: !!resProofOfAddress,
      emiratesId: isUAE ? !!emiratesId : true,
      taxIdentificationNumber: usCitizen ? !!taxIdentificationNumber : true,
      acceptTradingTerms,
      accountTradedByOthers,
      acknowledge: isUAE ? acknowledge : true,
    };

    // Handle document uploads
    // const uploadedFiles = [proofOfIdentity, proofOfIdentityBack, resProofOfAddress, emiratesId];

    if (!isRestricted && !proofOfIdentity && !resProofOfAddress) {
      validationMessages.push("Please upload the requested documents.");
      validations.proofOfIdentity = false;
      validations.resProofOfAddress = false;
    }

    if (isUAE && !emiratesId) {
      validationMessages.push("Please upload Emirates ID.");
      validations.emiratesId = false;
    }

    // Duplicate file check
    // const uniqueFiles = new Set(uploadedFiles.filter(Boolean));
    // if (uniqueFiles.size !== uploadedFiles.filter(Boolean).length) {
    //   toast.error("Uploaded files cannot be the same.");
    //   return false;
    // }

    // Update field-level errors
    setValidationErrors({
      step1: {
        firstName: !validations.firstName,
        email: !validations.email,
        phone: !validations.phone,
        platform: !validations.platform,
        accountType: !validations.accountType,
        country: !validations.country,
      },
      step2: {
        sourceOfFunds: !validations.sourceOfFunds,
        proofOfIdentity: !validations.proofOfIdentity,
        // resProofOfAddress: !validations.resProofOfAddress,
        taxIdentificationNumber: !validations.taxIdentificationNumber,
        emiratesId: !validations.emiratesId,
      },
      step3: {
        acceptTradingTerms: !validations.acceptTradingTerms,
        accountTradedByOthers: !validations.accountTradedByOthers,
      },
      step4: {
        acknowledge: !validations.acknowledge,
      },
    });

    // Check final result
    const allValid = Object.values(validations).every(Boolean);

    const isCreditAccountSelected =
      formData.step1.accountType === "63" ||
      formData.step1.accountType === "64";
    const creditOk =
      !isCreditCampaign ||
      !isCreditAccountSelected ||
      acceptedCreditTerms;
    if (isCreditCampaign && isCreditAccountSelected && !acceptedCreditTerms) {
      validationMessages.push("Please accept the Credit Terms & Conditions.");
    }

    if (!allValid) {
      validationMessages.push(
        "Please fill all the required fields correctly."
      );
    }

    if (!allValid || !creditOk) {
      const text = [...new Set(validationMessages)].join(" ");
      toast.error(text, { toastId: "morocco-form-validation" });
      return false;
    }

    return true;
  };

  const verifyFilesAccessible = async (imageList) => {
    if (!imageList || imageList.length === 0) return true;

    for (const item of imageList) {
      const file = item?.value?.[0];
      if (!file) continue;

      try {
        await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(true);
          reader.onerror = () => reject(new Error(`File not accessible: ${file.name}`));
          reader.readAsArrayBuffer(file); // Try reading bytes to ensure access
        });
      } catch (err) {
        console.error(`File check failed: ${file.name}`, err);
        toast.error(`"${file.name}" not accessible. Please reselect the file.`);
        return false;
      }
    }

    return true;
  };


  const submitForm = async (e) => {
    e.preventDefault();

    if (errorMessage) {
      toast.error("Email Exist!");
    }

    if (phoneError) {
      toast.error("Phone Exist!");
    }

    if (combineValidation() && !errorMessage && !phoneError) {

      const isFilesValid = await verifyFilesAccessible(imageList);
      if (!isFilesValid) {
        console.warn("File accessibility check failed — skipping lead creation.");
        return;
      }

      setLoading(true);
      data.acceptedTerms = true;
      data.acceptedRisk = true;
      data.acceptedPrivacy = true;
      data.acceptedExecutionPolicy = true;
      data.acceptedConflicts = true;
      data.phone =
        phoneNumber !== undefined ? phoneNumber + data.phone : data.phone;

      const postClient = await clientService.postLead(data);

      if (postClient && !postClient.data && postClient.length !== 0) {
        const formDataValue = new FormData();
        formDataValue.append("customerId", postClient.id);

        imageList.forEach((item) => {
          const file = item.value[0];
          if (file && file instanceof File) {
            formDataValue.append(item.key, file);
          }
        });

        setSubmittedData(postClient);

        const logData = {
          type: "userRegister",
          customerId: postClient && postClient.id,
          note: {
            note:
              ipInfo ?
                JSON.stringify(ipInfo) + ` urlLink=${window.location.href}` : `urlLink=${window.location.href}`,
          },
        };

        activitiesServices.postActivity(logData);

        try {
          if (imageList.length !== 0) {
            await clientService.uploadDocuments(formDataValue);
          }
        } catch (error) {
          console.error('Upload error:', error.message);
          if (error.message.includes("ERR_FILE_NOT_FOUND")) {
            toast.error("File not found. Please reselect the document and try again.");
          } else {
            toast.error("Network error during document upload.");
          }
          setSubmittedData("");
          setLoading(false);
          return; // stop further actions
        }

        setLoading(false);
        toast.success("Successfully Registered!");
      } else {
        console.log("error: ", postClient);
        setLoading(false);
        toast.error(postClient.data.message);
      }
    }
  };

  const updateListFunction = (key, files) => {
    // Check if the key already exists in the imageList
    const existingIndex = imageList.findIndex((entry) => entry.key === key);

    if (existingIndex !== -1) {
      // If the key already exists, update its value
      const updatedList = [...imageList];
      updatedList[existingIndex].value = files;

      setImageList(updatedList);
      console.log("file: ", imageList);
    } else {
      // If the key does not exist, add it as a new entry
      const newValue = {
        key,
        value: files,
      };

      const updatedList = [...imageList, newValue];
      setImageList(updatedList);
      console.log("file: ", imageList);
    }
  };

  const accountTypeValue = (platform) => {
    if (!platform) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        step1: {
          ...prevFormData.step1,
          accountType: "",
          accountTypeCurrency: "",
        },
      }));
      return;
    }
    if (isCreditCampaign) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        step1: {
          ...prevFormData.step1,
          accountType: "",
          accountTypeCurrency: "",
        },
      }));
      console.log(
        "[MoroccoForm] platform changed during IB credit campaign; account type cleared for manual pick"
      );
      return;
    }
    const accountType =
      morocco === false
        ? platform === "MT5"
          ? "2"
          : "14"
        : platform === "MT5"
          ? "42"
          : "38";

    setFormData((prevFormData) => ({
      ...prevFormData,
      step1: {
        ...prevFormData.step1,
        accountType,
        accountTypeCurrency: "USD",
      },
    }));
  };

  const handleChange = (selectedOption) => {
    const country = selectedOption ? selectedOption.value : null;

    if (formData.step1.platform || formData.step1.accountType) {
      formData.step1.platform = '';
      formData.step1.accountType = '';
    }

    if (country) {
      const selectedCountryData = countriesData.find(
        (item) => item.name === country
      );
      if (selectedCountryData) {
        if (selectedCountryData.name === "MOROCCO") {
          reloadHandler("MOROCCO");
        }

        setSelectedCountryCode(selectedCountryData.iso2.toLowerCase());
        formValueChange("step1", "country", selectedCountryData.name);
        formValueChange("step1", "countryCode", selectedCountryData.iso2);
        formValueChange("step2", "residency", selectedCountryData.name);
        formValueChange("step2", "residencyCode", selectedCountryData.iso2);
      }
    }
  };

  const countryOptions = countryList.map((item) => ({
    value: item.name,
    label: item.name,
  }));

  return (
    <div
      className="formBody"
      style={{
        fontSize:
          i18n.language === "ar" || i18n.language === "ir" ? "15px" : "",
      }}
    >
      <div id="recaptcha-container" style={{ display: "none" }}></div>{" "}
      <>
        <CustomForm>
          <div className="justify mt-2">
            <Row
              className={`${i18n.language === "ar" || i18n.language === "ir"
                ? "flex-row-reverse text-end"
                : ""
                } mb-2`}
            >
              <Col md={12} lg={6}>
                <FormGroup id="signupForm">
                  <Label>{t("FullName")}</Label>
                  <div className="input-group">
                    <Input
                      className={
                        "form-control " +
                        (!validationErrors.step1.firstName ||
                          formData.step1.firstName
                          ? ""
                          : "is-invalid")
                      }
                      name="firstName"
                      type="text"
                      required=""
                      placeholder="John"
                      value={formData.step1.firstName}
                      onChange={(e) => {
                        // Remove non-alphanumeric characters except spaces
                        let cleanedInput = e.target.value.replace(
                          /[^a-zA-Z0-9 ]/g,
                          ""
                        );

                        // Split the input into words, capitalize the first letter of each word, and join them back
                        let capitalizedInput = cleanedInput
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ");

                        // Update the form value
                        formValueChange("step1", "firstName", capitalizedInput);
                      }}
                    />
                  </div>
                </FormGroup>
              </Col>
              <Col md={12} lg={6}>
                <FormGroup>
                  <Label>{t("EmailAddress")}</Label>
                  <div className="input-group">
                    <Input
                      className={
                        "form-control " +
                        (!validationErrors.step1.email || formData.step1.email
                          ? ""
                          : "is-invalid")
                      }
                      type="email"
                      name="email"
                      validation={{ required: true }}
                      value={formData.step1.email}
                      placeholder="john@gmail.com"
                      invalid={emailError === 1 && formData.step1.email !== ""} // Invalid if emailError is 1 and email is not empty
                      valid={emailError === 0 && formData.step1.email !== ""} // Valid if emailError is 0 and email is not empty
                      onChange={(e) =>
                        formValueChange("step1", e.target.name, e.target.value)
                      }
                    />
                  </div>
                  {errorMessage && (
                    <span className="text-danger">Email Already Exist</span>
                  )}
                </FormGroup>
              </Col>
            </Row>
            <Row
              className={`${i18n.language === "ar" || i18n.language === "ir"
                ? "flex-row-reverse text-end"
                : ""
                } mb-2`}
            >
              <Col md={12}>
                <Row
                  className={`${i18n.language === "ar" || i18n.language === "ir"
                    ? "flex-row-reverse text-end"
                    : ""
                    }`}
                >
                  <Col md={12} lg={6}>
                    <FormGroup>
                      <Label>{t("CountryOfResidence")}</Label>
                      <Select
                        className={`mb-3 ${!validationErrors.step1.country ||
                          formData.step1.country
                          ? ""
                          : "is-invalid"
                          }`}
                        name="country"
                        options={countryOptions}
                        value={countryOptions.find(
                          (option) => option.value === formData.step1.country
                        )}
                        onChange={handleChange}
                        placeholder="-- Select --"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col md={12} lg={6} className="phoneNum">
                    <Label>{t("PhoneNumber")}</Label>
                    <IntlTelInput
                      name="phone"
                      containerClassName="intl-tel-input"
                      inputClassName={
                        "form-control " +
                        (!validationErrors.step1.phone || formData.step1.phone
                          ? ""
                          : "is-invalid")
                      }
                      style={{ width: "100%" }}
                      maxLength={15}
                      format="true"
                      defaultCountry={selectedCountryCode || "ae"}
                      useMobileFullscreenDropdown={false}
                      value={formData.step1.phone} // Ensure the value is set correctly
                      // onSelectFlag={(selectedCountryData, fullNumber, isvalid, currentNumber) => {
                      //     setCountryid(fullNumber && fullNumber.iso2 && fullNumber.iso2.toUpperCase());
                      // }}

                      // onPhoneNumberChange={(
                      //   status,
                      //   value,
                      //   countryData,
                      //   number,
                      //   id
                      // ) => {
                      //   setPhoneNumber(countryData.dialCode);
                      //   formValueChange("step1", "phone", value);
                      // }}
                      onPhoneNumberChange={(
                        status,
                        value,
                        countryData,
                        number,
                        id
                      ) => {
                        let cleanValue = value;

                        // Remove leading 0 (for mobile numbers like 05xxxx → 5xxxx)
                        if (cleanValue.startsWith("0")) {
                          cleanValue = cleanValue.substring(1);
                        }

                        // Final number without leading zero
                        setPhoneNumber(countryData.dialCode);
                        formValueChange("step1", "phone", cleanValue);  // Save cleaned value only
                      }}
                    />
                    {phoneError && (
                      <span className="text-danger">Phone Already Exist</span>
                    )}
                  </Col>
                  <Col md={12} lg={4}>
                    <FormGroup>
                      <Label>{t("Profession")}</Label>
                      <div className="input-group">
                        <Input
                          className={
                            !validationErrors.step2.sourceOfFunds ||
                              formData.step2.sourceOfFunds
                              ? ""
                              : "is-invalid"
                          }
                          type="select"
                          name="sourceOfFunds"
                          value={formData.step2.sourceOfFunds}
                          required=""
                          onChange={(e) => {
                            if (e.target.value !== "") {
                              formValueChange(
                                "step2",
                                e.target.name,
                                e.target.value
                              );
                              if (e.target.value === "Salaried") {
                                formValueChange(
                                  "step2",
                                  "sourceOfFundsCode",
                                  "SAL"
                                );
                              } else if (e.target.value === "Self-Employed") {
                                formValueChange(
                                  "step2",
                                  "sourceOfFundsCode",
                                  "SLF"
                                );
                              } else if (e.target.value === "Student") {
                                formValueChange(
                                  "step2",
                                  "sourceOfFundsCode",
                                  "STU"
                                );
                              } else if (e.target.value === "Freelancer") {
                                formValueChange(
                                  "step2",
                                  "sourceOfFundsCode",
                                  "FRE"
                                );
                              } else if (e.target.value === "Management") {
                                formValueChange(
                                  "step2",
                                  "sourceOfFundsCode",
                                  "MAN"
                                );
                              } else {
                                formValueChange(
                                  "step2",
                                  "sourceOfFundsCode",
                                  "UNE"
                                );
                              }
                            }
                          }}
                        >
                          <option value="">-- Select --</option>
                          <option value="Salaried">Salaried</option>
                          <option value="Self-Employed">Self-Employed</option>
                          <option value="Student">Student</option>
                          <option value="Freelancer">Freelancer</option>
                          <option value="Management">Management</option>
                          <option value="Unemployed">Unemployed</option>
                        </Input>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md={12} lg={4}>
                    <FormGroup>
                      <Label>{t("Platform")}</Label>
                      <div className="input-group">
                        <Input
                          type="select"
                          name="platform"
                          className={
                            !validationErrors.step1.platform ||
                              formData.step1.platform
                              ? ""
                              : "is-invalid"
                          }
                          value={formData.step1.platform}
                          onChange={(e) => {
                            formValueChange(
                              "step1",
                              e.target.name,
                              e.target.value
                            );
                            accountTypeValue(e.target.value);
                          }}
                        >
                          {referrar === "98724816" ? (
                            <option value="MT4">MT4</option>
                          ) : (
                            <>
                              <option value="">-- Select --</option>
                              <option value="MT5">MT5</option>
                              {!ptrValue && (
                                <option value="GTN">GODO Invest</option>
                              )}
                              {/* {!ptrValue && (
                                <option value="cTrader">cTrader</option>
                              )} */}
                              <option value="MT4">MT4</option>
                            </>
                          )}
                        </Input>
                      </div>
                    </FormGroup>
                  </Col>
                  <Col md={12} lg={4}>
                    <FormGroup>
                      <Label>{t("AccountType")}</Label>
                      <div className="input-group">
                        <Input
                          type="select"
                          name="accountType"
                          className={
                            !validationErrors.step1.accountType ||
                              formData.step1.accountType
                              ? ""
                              : "is-invalid"
                          }
                          value={formData.step1.accountType}
                          onChange={(e) => {
                            if (e.target.value !== "") {
                              formValueChange(
                                "step1",
                                e.target.name,
                                e.target.value
                              );
                              const safeTypes = Array.isArray(filteredAccountTypes)
                                ? filteredAccountTypes
                                : [];
                              const accountCurrency = safeTypes.filter(
                                (account) =>
                                  Number(account.Id) ===
                                  parseInt(e.target.value, 10)
                              );
                              if (accountCurrency && accountCurrency.length > 0) {
                                formValueChange(
                                  "step1",
                                  "accountTypeCurrency",
                                  accountCurrency[0].Currency
                                );
                              }
                              // Reset credit terms if not a credit account
                              const selectedVal = e.target.value;
                              if (selectedVal !== "63" && selectedVal !== "64") {
                                setAcceptedCreditTerms(false);
                              }
                            }
                          }}
                        >
                          <option value="">
                            {isCreditCampaignLoading
                              ? "-- Loading credit add-ons… --"
                              : "-- Select --"}
                          </option>
                          {referrar === "98724816" ? (
                            <option value="55">MANAGED</option>
                          ) : (
                            sortAccountTypesForSelect(
                              Array.isArray(filteredAccountTypes)
                                ? filteredAccountTypes
                                : []
                            ).map((item) => (
                              <option key={item.Id} value={String(item.Id)}>
                                {formatAccountTypeSelectLabel(item)}
                              </option>
                            ))
                          )}
                        </Input>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
            </Row>
            <div
              className={`z-50 d-flex flex-wrap align-items-center justify-content-center ${i18n.language === "ar" || i18n.language === "ir"
                ? "justify-content-lg-end"
                : "justify-content-lg-start"
                } fileUploadBox mb-2 ${i18n.language === "ar" || i18n.language === "ir"
                  ? "flex-row-reverse text-end"
                  : ""
                }`}
            >
              <div style={{ flex: "1px" }}>
                <Label for="proofOfIdentity" className="uploadButton fw-bold">
                  {" "}
                  {t("ProofOfIdentity")}
                  <div
                    className="tooltip"
                    style={{
                      opacity: "1",
                      position: "relative",
                      top: "-1px",
                      ...(i18n.language === "ar" || i18n.language === "ir"
                        ? { left: "0" }
                        : { left: "5px" }),
                    }}
                  >
                    <img
                      src={toolTipIcon}
                      alt="infoIcon"
                      className={`${(i18n.language === "ar" || i18n.language === "ir") &&
                        "ms-2"
                        }`}
                      width={"10px"}
                    />
                    <span
                      className={` ${i18n.language === "ar" || i18n.language === "ir"
                        ? "tooltiptextArabic"
                        : "tooltiptext"
                        }`}
                    >
                      {t("POIToolTipHeading")} <b>{t("ONE")}</b>{" "}
                      {t("POIToolTipEnding")}
                      <ul>
                        <li>{t("POIToolTipList1")}</li>
                        <li>{t("POIToolTipList2")}</li>
                        <li>{t("POIToolTipList3")}</li>
                      </ul>
                    </span>
                  </div>
                  <div className="fileUploadButton">
                    <img src={uploadIcon} alt="uploadIcon" width={"40px"} />
                    <p className="m-0 text-center">
                      {" "}
                      {formData.step2.proofOfIdentity
                        ? formData.step2.proofOfIdentity?.split("\\")[2]?.slice(0, 13)
                        : "Choose a file"}
                    </p>
                  </div>
                </Label>
                <Input
                  className={
                    "d-none mb-3 mb-md-0 " +
                    (!validationErrors.step2.proofOfIdentity ||
                      formData.step2.proofOfIdentity
                      ? ""
                      : "is-invalid")
                  }
                  type="file"
                  name="proofOfIdentity"
                  id="proofOfIdentity"
                  accept=".jpg, .jpeg, .png, .pdf, .heic"
                  onChange={(e) => {
                    const maxFileSize = 5 * 1024 * 1024; // 2 MB in bytes

                    const fileExtension = ["jpg", "jpeg", "png", "pdf", "heic"];
                    const fileName = e.target.value;
                    const file = e.target.files[0];
                    const fileExtensionCheck = fileName
                      .split(".")
                      .pop()
                      .toLowerCase();

                    if (file) {
                      if (file.size > maxFileSize) {
                        alert("File size exceeds the limit of 5 MB.");
                        e.target.value = "";
                        formValueChange("step2", e.target.name, e.target.value);
                      } else if (fileExtension.includes(fileExtensionCheck)) {
                        updateListFunction("PROOF_OF_ID", [e.target.files[0]]);
                        formValueChange("step2", e.target.name, e.target.value);
                      } else {
                        alert(
                          "Please Upload files with extension jpg, jpeg, png, pdf, heic"
                        );
                        e.target.value = "";
                        formValueChange("step2", e.target.name, e.target.value);
                      }
                    }
                  }}
                />
              </div>
              <div style={{ flex: "1px" }}>
                <Label
                  for="proofOfIdentityBack"
                  className="uploadButton fw-bold"
                  style={{
                    letterSpacing: i18n.language === "ru" ? "-1px" : "normal",
                  }}
                >
                  {t("ProofOfIdentityBack")}
                  <div className="fileUploadButton">
                    <img src={uploadIcon} alt="uploadIcon" width={"40px"} />
                    <p className="m-0 text-center">
                      {formData.step2.proofOfIdentityBack
                        ? formData.step2.proofOfIdentityBack?.split("\\")[2]?.slice(0, 13)
                        : "Choose a file"}
                    </p>
                  </div>
                </Label>
                <Input
                  className={"d-none mb-3 mb-md-0 "}
                  type="file"
                  name="proofOfIdentityBack"
                  id="proofOfIdentityBack"
                  accept=".jpg, .jpeg, .png, .pdf, .heic"
                  onChange={(e) => {
                    const maxFileSize = 5 * 1024 * 1024; // 2 MB in bytes

                    const fileExtension = ["jpg", "jpeg", "png", "pdf", "heic"];
                    const fileName = e.target.value;
                    const file = e.target.files[0];
                    const fileExtensionCheck = fileName
                      .split(".")
                      .pop()
                      .toLowerCase();

                    if (file) {
                      if (file.size > maxFileSize) {
                        alert("File size exceeds the limit of 5 MB.");
                        e.target.value = "";
                        formValueChange("step3", e.target.name, e.target.value);
                      } else if (fileExtension.includes(fileExtensionCheck)) {
                        updateListFunction("PROOF_OF_ID_BACK", [
                          e.target.files[0],
                        ]);
                        formValueChange("step2", e.target.name, e.target.value);
                      } else {
                        alert(
                          "Please Upload files with extension jpg, jpeg, png, pdf, heic"
                        );
                        e.target.value = "";
                        formValueChange("step2", e.target.name, e.target.value);
                      }
                    }
                  }}
                />
              </div>
              <div style={{ flex: "1px" }}>
                <Label className="uploadButton fw-bold" for="resProofOfAddress">
                  {" "}
                  {t("ProofOfAddress")}
                  <div
                    className="tooltip"
                    style={{
                      opacity: "1",
                      zIndex: "5",
                      position: "relative",
                      top: "0px",
                      ...(i18n.language === "ar" || i18n.language === "ir"
                        ? { left: "0" }
                        : { left: "5px" }),
                    }}
                  >
                    <img
                      src={toolTipIcon}
                      alt="infoIcon"
                      className={`${(i18n.language === "ar" || i18n.language === "ir") &&
                        "ms-2"
                        }`}
                      width={"10px"}
                    />
                    <span
                      className={` ${i18n.language === "ar" || i18n.language === "ir"
                        ? "tooltiptextRightArabic"
                        : "tooltiptextRight"
                        }`}
                    >
                      {t("ToolTipHeading")} <b>{t("ToolTipBoldHeading")} </b>
                      {t("ToolTipEnding")}
                      <ul>
                        <li>{t("ToolTipList1")}</li>
                        <li>{t("ToolTipList2")}</li>
                        <li>{t("ToolTipList3")}</li>
                        <li>{t("ToolTipList4")}</li>
                        <li>{t("ToolTipList5")}</li>
                        <li>{t("ToolTipList6")}</li>
                      </ul>
                    </span>
                  </div>
                  <div
                    className={`fileUploadButton ${(i18n.language === "ar" || i18n.language === "ir") &&
                      !selectedCountryCode
                      ? "arabicTranslate"
                      : {}
                      }`}
                  >
                    <img src={uploadIcon} alt="uploadIcon" width={"40px"} />
                    <p className="m-0 text-center">
                      {formData.step2.resProofOfAddress
                        ? formData.step2.resProofOfAddress?.split("\\")[2]?.slice(0, 13)
                        : "Choose a file"}
                    </p>
                  </div>
                </Label>
                <div className="input-group mb-1">
                  <Input
                    className={
                      "d-none mb-3 mb-md-0 form-control " +
                      (!validationErrors.step2.resProofOfAddress ||
                        formData.step2.resProofOfAddress
                        ? ""
                        : "is-invalid")
                    }
                    name="resProofOfAddress"
                    id="resProofOfAddress"
                    type="file"
                    accept=".jpg, .jpeg, .png, .pdf, .heic"
                    onChange={(e) => {
                      const maxFileSize = 5 * 1024 * 1024; // 2 MB in bytes

                      const fileExtension = [
                        "jpg",
                        "jpeg",
                        "png",
                        "pdf",
                        "heic",
                      ];
                      const fileName = e.target.value;
                      const file = e.target.files[0];
                      const fileExtensionCheck = fileName
                        .split(".")
                        .pop()
                        .toLowerCase();

                      if (file) {
                        if (file.size > maxFileSize) {
                          alert("File size exceeds the limit of 5 MB.");
                          e.target.value = "";
                          formValueChange(
                            "step3",
                            e.target.name,
                            e.target.value
                          );
                        } else if (fileExtension.includes(fileExtensionCheck)) {
                          updateListFunction("RES_PROOF_OF_ADDRESS", [
                            e.target.files[0],
                          ]);
                          formValueChange(
                            "step2",
                            e.target.name,
                            e.target.value
                          );
                        } else {
                          alert(
                            "Please Upload files with extension jpg, jpeg, png, pdf, heic"
                          );
                          e.target.value = "";
                          formValueChange(
                            "step2",
                            e.target.name,
                            e.target.value
                          );
                        }
                      }
                    }}
                  />
                </div>
              </div>
              {selectedCountryCode === "ae" && (
                <div style={{ flex: "1px" }}>
                  <Label className="uploadButton fw-bold" for="emiratesId">
                    {" "}
                    {t("EMIRATESID")}
                    <div className="fileUploadButton">
                      <img src={uploadIcon} alt="uploadIcon" width={"40px"} />
                      <p className="m-0 text-center">
                        {formData.step2.emiratesId
                          ? formData.step2.emiratesId?.split("\\")[2]?.slice(0, 13)
                          : "Choose a file"}
                      </p>
                    </div>
                  </Label>
                  <div className="input-group mb-1">
                    <Input
                      className={
                        "d-none mb-3 mb-md-0 form-control " +
                        (!validationErrors.step2.emiratesId ||
                          formData.step2.emiratesId
                          ? ""
                          : "is-invalid")
                      }
                      name="emiratesId"
                      id="emiratesId"
                      type="file"
                      accept=".jpg, .jpeg, .png, .pdf, .heic"
                      onChange={(e) => {
                        const maxFileSize = 5 * 1024 * 1024; // 2 MB in bytes

                        const fileExtension = [
                          "jpg",
                          "jpeg",
                          "png",
                          "pdf",
                          "heic",
                        ];
                        const fileName = e.target.value;
                        const file = e.target.files[0];
                        const fileExtensionCheck = fileName
                          .split(".")
                          .pop()
                          .toLowerCase();

                        if (file) {
                          if (file.size > maxFileSize) {
                            alert("File size exceeds the limit of 5 MB.");
                            e.target.value = "";
                            formValueChange(
                              "step3",
                              e.target.name,
                              e.target.value
                            );
                          } else if (
                            fileExtension.includes(fileExtensionCheck)
                          ) {
                            updateListFunction("EMIRATES_ID", [
                              e.target.files[0],
                            ]);
                            formValueChange(
                              "step2",
                              e.target.name,
                              e.target.value
                            );
                          } else {
                            alert(
                              "Please Upload files with extension jpg, jpeg, png, pdf, heic"
                            );
                            e.target.value = "";
                            formValueChange(
                              "step2",
                              e.target.name,
                              e.target.value
                            );
                          }
                        }
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <Row
              className={`${i18n.language === "ar" || i18n.language === "ir"
                ? "flex-row-reverse text-end"
                : ""
                } ${!validationErrors.step3.accountTradedByOthers ||
                  formData.step3.accountTradedByOthers
                  ? "text-black"
                  : "text-danger"
                } mt-2 mb-2`}
            >
              <Col
                md={12}
                lg={6}
                style={{
                  direction:
                    (i18n.language === "ar" || i18n.language === "fa") && "rtl",
                  marginBottom: "15px",
                }}
              >
                <Label>{t("UsCitizen")}</Label>
                <div
                  style={{
                    direction:
                      (i18n.language === "ar" || i18n.language === "fa") &&
                      "rtl",
                  }}
                >
                  <div className="form-check form-check-inline">
                    <Input
                      className="form-check-input"
                      type="radio"
                      name="usCitizen"
                      id="usCitizenYes"
                      value="Yes"
                      checked={formData.step4.usCitizen === true}
                      onChange={(e) =>
                        formValueChange("step4", e.target.name, true)
                      }
                    />
                    <Label className="form-check-label" htmlFor="usCitizenYes">
                      {t("Yes")}
                    </Label>
                  </div>
                  <div className="form-check form-check-inline">
                    <Input
                      className="form-check-input"
                      type="radio"
                      name="usCitizen"
                      id="usCitizenNo"
                      value="No"
                      checked={formData.step4.usCitizen === false}
                      onChange={(e) =>
                        formValueChange("step4", e.target.name, false)
                      }
                    />
                    <Label className="form-check-label" htmlFor="usCitizenNo">
                      {t("No")}
                    </Label>
                  </div>
                </div>
              </Col>
              {formData.step4.usCitizen === true && (
                <Col md={12} lg={6} style={{ marginBottom: "15px" }}>
                  <Label>{t("SSN")}</Label>
                  <div
                    className={`input-group ${i18n.language === "ar" || i18n.language === "fa"
                      ? "align-items-end justify-content-end"
                      : ""
                      } `}
                  >
                    <Input
                      className={
                        "form-control " +
                        (formData.step4.usCitizen &&
                          !validationErrors.step2.taxIdentificationNumber
                          ? ""
                          : "is-invalid")
                      }
                      name="taxIdentificationNumber"
                      type="text"
                      value={formData.step2.taxIdentificationNumber}
                      required=""
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          // Only allow numbers
                          formValueChange("step2", e.target.name, value);
                        }
                      }}
                      placeholder="Enter SSN"
                    />
                  </div>
                </Col>
              )}
              <Col
                md={12}
                className={`d-flex ${i18n.language === "ar" || i18n.language === "ir"
                  ? "flex-row-reverse text-end"
                  : "justify-content-start"
                  } `}
              >
                <div className="mb-3 w-auto">
                  <div className="form-check form-check-inline mx-1">
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      name="accountTradedByOthers"
                      id="accountTradedByOthers"
                      value={formData.step3.accountTradedByOthers}
                      checked={formData.step3.accountTradedByOthers}
                      onChange={(e) =>
                        formValueChange(
                          "step3",
                          e.target.name,
                          e.target.checked
                        )
                      }
                    />
                  </div>
                </div>
                <Label>
                  {t("Agreement")}
                  <a
                    style={{
                      wordSpacing: "-1px",
                      padding: "0px 6px",
                      color: "#094D96",
                    }}
                    href="https://godocm.com/fr/limited-power-of-attorney-account-manager"
                    alt=""
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t("PowerofAttorney")}
                  </a>
                </Label>
              </Col>
              <Col
                md={12}
                className={`d-flex ${i18n.language === "ar" || i18n.language === "ir"
                  ? "flex-row-reverse text-end"
                  : "justify-content-start"
                  } ${!validationErrors.step3.acceptTradingTerms ||
                    formData.step3.acceptTradingTerms
                    ? "text-black"
                    : "text-danger"
                  } `}
              >
                <div className="mb-3 w-auto">
                  <div className="form-check form-check-inline mx-1">
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      name="acceptTradingTerms"
                      id="acceptTradingTerms"
                      value={formData.step3.acceptTradingTerms}
                      checked={formData.step3.acceptTradingTerms}
                      onChange={(e) =>
                        formValueChange(
                          "step3",
                          e.target.name,
                          e.target.checked
                        )
                      }
                    />
                  </div>
                </div>
                <Label>
                  {t("Approve")}
                  <a
                    style={{
                      wordSpacing: "-1px",
                      padding: "0px 6px",
                      color: "#094D96",
                    }}
                    href="https://www.godocm.com/wp-content/uploads/2025/01/Terms-of-Business.pdf"
                    alt=""
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t("TermsofBusiness")}
                  </a>
                  {isCreditCampaign &&
                  CREDIT_ACCOUNT_IDS.includes(
                    Number(formData.step1.accountType)
                  ) ? (
                    <>
                      {t("ApproveMidDocs")}
                      <a
                        style={{
                          wordSpacing: "-1px",
                          padding: "0px 6px",
                          color: "#094D96",
                        }}
                        href="https://godocm.com/Assets/T%26C/Credit%20Bonus-%20GODO.pdf"
                        alt=""
                        target="_blank"
                        rel="noreferrer"
                      >
                        {t("CreditBonusTerms")}
                      </a>
                      {t("ApproveAfterCredit")}
                    </>
                  ) : (
                    t("ApproveAfterTermsOnly")
                  )}
                  {t("Approve2And3")}
                  {isCreditCampaign &&
                    CREDIT_ACCOUNT_IDS.includes(
                      Number(formData.step1.accountType)
                    ) && t("ApproveClause4")}
                </Label>
              </Col>
              {isCreditCampaign && (formData.step1.accountType === "63" || formData.step1.accountType === "64") && (
                <Col
                  md={12}
                  className={`d-flex ${i18n.language === "ar" || i18n.language === "ir"
                    ? "flex-row-reverse text-end"
                    : "justify-content-start"
                    } ${acceptedCreditTerms ? "text-black" : "text-danger"} `}
                >
                  <div className="mb-3 w-auto">
                    <div className="form-check form-check-inline mx-1">
                      <Input
                        className="form-check-input"
                        type="checkbox"
                        name="acceptedCreditTerms"
                        id="acceptedCreditTerms"
                        checked={acceptedCreditTerms}
                        onChange={(e) => setAcceptedCreditTerms(e.target.checked)}
                      />
                    </div>
                  </div>
                  <Label>
                    I accept the{" "}
                    <a
                      style={{
                        wordSpacing: "-1px",
                        padding: "0px 6px",
                        color: "#094D96",
                      }}
                      href="https://godocm.com/Assets/T%26C/Credit%20Bonus-%20GODO.pdf"
                      alt="Credit Terms & Conditions"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Credit Terms & Conditions
                    </a>
                  </Label>
                </Col>
              )}
              <Col md={12} className={`d-flex ${i18n.language === "ar" || i18n.language === "ir"
                ? "flex-row-reverse text-end"
                : "justify-content-start"
                }`}>
                <div className="mb-1 w-auto">
                  <div className="form-check form-check-inline mx-1">
                    <Input
                      className="form-check-input"
                      type="checkbox"
                      name="parentId"
                      id="parentId"
                      value={formData.step1.parentId}
                      checked={couponCode}
                      onChange={() => setCopponCode(!couponCode)}
                    />
                  </div>
                </div>
                <Label>{t("CouponeCode")}</Label>
              </Col>
              {couponCode && <Col md={12}>
                <FormGroup>
                  <Input
                    className={"mb-3 "}
                    type="text"
                    name="couponeCode"
                    placeholder="######"
                    onChange={(e) => {
                      formValueChange('step1', 'couponeCode', e.target.value);
                    }}
                    value={formData.step1.couponeCode}
                  >
                  </Input>
                </FormGroup>
              </Col>}
              {selectedCountryCode === "ae" && (
                <Col
                  md={12}
                  className={`d-flex ${i18n.language === "ar" || i18n.language === "ir"
                    ? "flex-row-reverse text-end"
                    : "justify-content-start"
                    } ${!validationErrors.step4.acknowledge ||
                      formData.step4.acknowledge
                      ? "text-black"
                      : "text-danger"
                    } `}
                >
                  <div className="mb-3 w-auto">
                    <div className="form-check form-check-inline mx-1">
                      <Input
                        className="form-check-input"
                        type="checkbox"
                        name="acknowledge"
                        id="acknowledge"
                        value={formData.step4.acknowledge}
                        checked={formData.step4.acknowledge}
                        onChange={(e) =>
                          formValueChange(
                            "step4",
                            e.target.name,
                            e.target.checked
                          )
                        }
                      />
                    </div>
                  </div>
                  <Label>{t("GODOIFSLLC")}</Label>
                </Col>
              )}
            </Row>
          </div>
          <Col md={12}>
            <Button
              type="submit"
              onClick={(e) => submitForm(e)}
              className="submitButton"
            >
              {t("RegisterNow")}
            </Button>
          </Col>
        </CustomForm>
      </>
    </div>
  );
};
